import { useMemo, useState } from 'react'
import { groupBy } from 'lodash'
import { useSnapshot } from 'valtio'
import { configState } from '@/store'
import PromptModal from '@/components/PromptEditor/modal'
interface IPrompt {
  title: string
  real_prompt: string
  text: string
  [attributeName: string]: any
}

const PromptItem = ({ item, onClick }: any) => (
  <div
    className="cursor-pointer px-4 py-3 rounded-xl bg-[#0077FA08] hover:bg-[#0077FA1A]"
    onClick={onClick}
  >
    <div className="flex flex-col gap-1">
      <div className="text-sm font-medium">{item.title}</div>
      <div className="text-xs text-[#494C4F] line-clamp-2">
        {item.text || item.real_prompt.replace(/【|】|\n/g, '')}
      </div>
    </div>
  </div>
)

export default function PromptDrawer() {
  const { apps } = useSnapshot(configState)
  const [openModal, setOpenModal] = useState(false)
  const [editItem, setEditItem] = useState({})
  const [curTagInfo, setCurTagInfo] = useState({
    key: '全部',
    children: apps,
  })
  const groups = useMemo(() => {
    const list = Object.entries(groupBy(configState.apps, 'tag')).map(
      ([k, children]) => ({
        key: k,
        children,
      }),
    )
    const all = { key: '全部', children: configState.apps }
    setCurTagInfo(all)
    return [all, ...list]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apps])

  const handleClick = (item: IPrompt) => {
    setEditItem(item)
    setOpenModal(true)
    console.log('handleClick PromptItem =>', item)
  }

  return (
    <>
      <div className="flex flex-col relative py-5 h-full">
        <div className="grid grid-cols-4 gap-2 mb-2">
          {groups.map((item: any, index: number) => (
            <div
              key={item.key}
              className={`cursor-pointer flex items-center rounded-lg justify-center h-6 bg-[#1C1F2308] ${
                item.key === curTagInfo.key && 'text-white bg-content-first'
              }`}
              onClick={() => {
                setCurTagInfo(item)
              }}
            >
              {item.key}
            </div>
          ))}
        </div>
        <div className="h-full py-3 flex flex-col gap-3 overflow-y-auto scrollbar-none">
          {curTagInfo.children.map((item: any, index) => (
            <PromptItem
              item={item}
              key={item.title + index}
              onClick={() => {
                handleClick(item)
              }}
            />
          ))}
        </div>
      </div>
      <PromptModal
        open={openModal}
        onCancel={() => {
          setOpenModal(false)
        }}
        onOK={() => {
          setOpenModal(false)
        }}
        data={editItem}
      />
    </>
  )
}
